import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { FilterViewModelForOwner } from 'src/app/core/models/regulation/filter-view.model';
import { SelfAssessment } from 'src/app/core/models/self-assessment/self-assessment';
import { SelfAssessmentDetailHistory, SelfAssessmentT2DetailHistory } from 'src/app/core/models/self-assessment/self-assessment-detail-history';
import { SelfAssessmentAllDropdownList, SelfAssessmentDetailsDD, SelfAssessmentT2AllDropdownList, SelfAssessmentT2DetailsDD } from 'src/app/core/models/self-assessment/self-assessment-details-dd';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { UpdateSelfAssessmentModel } from 'src/app/core/models/self-assessment/update-self-assessment-model';
import { UserProfile } from 'src/app/core/models/user';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
//import * as customBuild from './../../../../ckCustomeBuild/build/ckeditor';
import { GDPRService } from 'src/app/core/services/rulebook';
import { MatDialog } from '@angular/material/dialog';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { RegulationService } from 'src/app/core/services/regulation';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { ActivatedRoute, NavigationExtras, NavigationStart } from '@angular/router';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Role } from 'src/app/core/models/user-management/role';
import { MasterHelper } from 'src/app/core/utilities';
import { SelfAssessmentVersionModel } from 'src/app/core/models/self-assessment/self-assessment-version-model';
import { MatChipInputEvent } from '@angular/material/chips';
import { FileType } from 'src/app/core/enums/user/file-type';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ModalDialogComponent } from '../../distributed-ui-components/modal-dialog/modal-dialog.component';
import { SelfAssessmentDialogComponent } from '../../self-assessment/self-assessment-dialog/self-assessment-dialog.component';
import { VersionFilterViewModel } from 'src/app/core/models/self-assessment/version-filter-view-model';
import { SelfAssessmentCkDataSaveModel, UpdateSelfAssessmentT2Model } from 'src/app/core/models/self-assessmentT2/update-self-assessmentT2-model';
import { ConfirmApprove, SelfAssessmentNew, SelfAssessmentT2 } from 'src/app/core/models/self-assessmentT2/self-assessmentT2';
import { VersionFilterViewT2Model } from 'src/app/core/models/self-assessmentT2/version-filter-viewT2-model';
import { SelfAssessmentT2VersionModel } from 'src/app/core/models/self-assessmentT2/self-assessmentT2-version-model';
import { any } from 'underscore';
import { revisionHistoryAccessTypeEnum, selfAssessmentTemp2CkEditorTypeEnum } from 'src/app/core/models/ckEditor/revisionData';
import { userInfo } from 'os';
import * as signalR from "@microsoft/signalr";
import { SignalRService } from 'src/app/core/services/signalR/signal-r.service';
import { environment } from '../../../../environments/environment';
import { LoggedUserItem, ckEditorBroadcastMessage } from 'src/app/core/models/signalR/ckEditorBroadcastMessage';
import { CopyDialogComponent } from '../../distributed-ui-components/copy-dialog/copy-dialog.component';
import { CkEditorRevisionComponent } from '../../shared/ck-editor-revision/ck-editor-revision.component';
import { ChangeDetailComponent } from '../../change-detail/change-detail.component';


@Component({
  selector: 'app-self-assessment-t2-details',
  templateUrl: './self-assessment-t2-details.component.html',
  styleUrls: ['./self-assessment-t2-details.component.scss'],
})
export class SelfAssessmentT2DetailsComponent {
  selfAssessmentNew: SelfAssessmentNew;
  selfAssessmentT2DD: SelfAssessmentT2DetailsDD;
  selfAssessmentDocument: Array<SelfAssessmentDocumentModel>;
  updateSADetails: UpdateSelfAssessmentT2Model;
  effectiveDate: string;
  isLoading = false;
  isToastShow = false;
  toastModel: ToastViewModel;
  libraryMenu: Array<MenuItemModel>;
  isAssessmentLoader = false;
  isInterpretationLoader = false;
  isDataJudgementLoader = false;
  isComplianceGapsLoader = false;
  isEnhancementLoader = false;
  isReviewLoader = false;
  isLoadingDD = false;
  formattedDesc: string;
  isSaved = false;

  //Checking Last Edited date
  isAssessmentLastEdited = false;
  isReviewLastEdited = false;
  isGapLastEdited = false;
  isEnhancementLastEdited = false;
  isIntepretationsLastEdited = false;
  isJudgementLastEdited = false;
  isApprovalLastEdited = false;
  isConfirmApprovalLastEdited = false;

  saDetailHistory: SelfAssessmentDetailHistory;
  saT2DetailHistory: SelfAssessmentT2DetailHistory;

  assessorDD: string[] = [];
  reviewerDD: string[] = [];
  approverDD: string[] = [];

  searchedAssessor: FilterViewModel[] = [];
  searchedApprover: FilterViewModel[] = [];
  searchedReviewer: FilterViewModel[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  isLoadingFilters = false;

  searchAssessorCntrl: FormControl = new FormControl();
  searchApproverCntrl: FormControl = new FormControl();
  searchReviewerCntrl: FormControl = new FormControl();

  @ViewChild('assessorInput')
  assessorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('assessorAutocomplete')
  assessorAutocomplete!: MatAutocomplete;

  @ViewChild('approverInput')
  approverInput!: ElementRef<HTMLInputElement>;
  @ViewChild('approverAutocomplete')
  approverAutocomplete!: MatAutocomplete;

  @ViewChild('reviewerInput')
  reviewerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('reviewerAutocomplete')
  reviewerAutocomplete!: MatAutocomplete;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  isVersioned = false;

  currentUserRole = '';
  user: UserProfile;
  isSADetails1 = false;
  isSADetails2 = false;
  isSADetails3 = false;
  isSADetails4 = false;
  isSADetails5 = false;
  isSADetails6 = false;
  isSADetails7 = false;
  //For Owner
  ownerDD: string[] = [];
  @ViewChild('ownerAutocomplete')
  ownerAutocomplete!: any;
  @ViewChild('trigautoOwner')
  trigautoOwner!: MatAutocompleteTrigger;
  @ViewChild('ownerInput')
  ownerInput!: ElementRef<HTMLInputElement>;
  allSearchedOwner: FilterViewModelForOwner[] = [];
  searchOwnerCntrl: FormControl = new FormControl();
  changeFields: Array<string> = [];
  versionNo: number = 0;

  //public Editor = customBuild;
  selfAssessmentAllDropdownList: SelfAssessmentAllDropdownList;
  selfAssessmentT2AllDropdownList: SelfAssessmentT2AllDropdownList;
  @Input()
  selfAssessmentId!: number;
  @Input()
  filterType!: string;
  @ViewChild('uploadEviReview') uploadEviReview: any;
  @ViewChild('uploadEviAssessment') uploadEviAssessment: any;
  @ViewChild('uploadEviInterpretation') uploadEviInterpretation: any;
  @ViewChild('uploadEviDataJudgement') uploadEviDataJudgement: any;
  @ViewChild('uploadEviComplianceGaps') uploadEviComplianceGaps: any;
  @ViewChild('uploadEviEnhancement') uploadEviEnhancement: any;

  //Static dropdown till Database fixing
  assessmentCategory: Array<string> = [];
  assessmentTeam: Array<string> = [];
  assessmentStatus: Array<string> = [];
  complianceStatus: Array<string> = [];
  interpretations: Array<string> = [];
  judgement: Array<string> = [];
  gaps: Array<string> = [];
  enhancement: Array<string> = [];
  riskRecommendation: Array<string> = [];
  riskRecommendationStatus: Array<string> = [];
  approvalStatus: Array<string> = [];
  confirmApproval: ConfirmApprove[] = [];
  reviewerTeam: Array<string> = [];
  approvalTeam: Array<string> = [];
  reviewStatus: Array<string> = [];
  editorType: selfAssessmentTemp2CkEditorTypeEnum | undefined;
  isApprovedForDisable = false;
  //Have to do reviewStatus also
  accessType: revisionHistoryAccessTypeEnum | undefined;
  reviewAccessType: revisionHistoryAccessTypeEnum | undefined;
  approverAccessType: revisionHistoryAccessTypeEnum | undefined;
  private _hubConnection!: signalR.HubConnection;
  logedInUserList: LoggedUserItem[] = [];
  alertDialogModel: AlertDialogModel;
  locationName: string = '';
  @ViewChildren(CkEditorRevisionComponent) ckEditorComponent:
    | QueryList<CkEditorRevisionComponent>
    | undefined;
  isOverAllAssessmentDisabled: boolean = true;
  isInterpretationDisabled: boolean = true;
  isJudgementDisabled: boolean = true;
  isGapDisabled: boolean = true;
  isEnhancementDetailsDisabled: boolean = true;
  isReviewDetailsDisabled: boolean = true;
  isApprovalDetailsDisabled: boolean = true;
  idList: number[]=[];
  //@ViewChild(CkEditorRevisionComponent) ckEditorComponent: CkEditorRevisionComponent | undefined;
  constructor(
    private gdprService: GDPRService,
    public dialog: MatDialog,
    private sessionService: SessionService,
    private regulationService: RegulationService,
    private analyticsService: AnalyticsService,
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private signalRService: SignalRService,
    private ref: ChangeDetectorRef,
    private router: Router
  ) {
    this.selfAssessmentNew = new SelfAssessmentNew();
    this.selfAssessmentT2DD = new SelfAssessmentT2DetailsDD();
    this.updateSADetails = new UpdateSelfAssessmentT2Model();

    this.effectiveDate = '';
    this.toastModel = new ToastViewModel();
    this.libraryMenu = [];
    this.selfAssessmentDocument = [];
    this.formattedDesc = '';
    this.saDetailHistory = new SelfAssessmentDetailHistory();
    this.saT2DetailHistory = new SelfAssessmentT2DetailHistory();
    this.user = new UserProfile();
    this.selfAssessmentAllDropdownList = new SelfAssessmentAllDropdownList();
    this.selfAssessmentT2AllDropdownList =
      new SelfAssessmentT2AllDropdownList();
    this.alertDialogModel = new AlertDialogModel();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.onNavigationStart();
      }
    });
    this.route.paramMap.subscribe(params => {
      const state = window.history.state;
      if (state && state.idList) {
        this.idList = state.idList;
      } else {
        this.idList = [];
      }
    });
  }
  ngOnInit(): void {
    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl('https://' + window.location.host + '/notify')
      .build();
    this._hubConnection
      .start()
      .then(() => {})
      .catch((err: any) => {});
    this._hubConnection.on(
      'BroadcastSAT2Message',
      (message: ckEditorBroadcastMessage) => {
        if (
          this.selfAssessmentId == message.selfAssessmentId &&
          this.user.externalUserId != message.userId
        ) {
          //alert( "ckeditor is updated by others, please reload it");
          alert(
            'Editors are updated by ' +
              message.userName +
              ', please reload the page, otherwise you will lose the updated information'
          );
        }
      }
    );
    this._hubConnection.on(
      'BroadcastSAT2JoinPage',
      (message: ckEditorBroadcastMessage) => {
        if (this.locationName == message.url) {
          let userArray: any[] = JSON.parse(message.loggedInUsers);
          this.logedInUserList = userArray.filter(
            (item) => item.UserId !== this.user.externalUserId
          );
          this.logedInUserList.sort((a, b) =>
            a.userName.localeCompare(b.userName)
          );
          this.ref.detectChanges();
        }
      }
    );
    this._hubConnection.on(
      'BroadcastSAT2LeavePage',
      (message: ckEditorBroadcastMessage) => {
        if (this.locationName == message.url) {
          let userArray: any[] = JSON.parse(message.loggedInUsers);
          this.logedInUserList = userArray.filter(
            (item) => item.UserId !== this.user.externalUserId
          );
          this.logedInUserList.sort((a, b) =>
            a.userName.localeCompare(b.userName)
          );
          this.ref.detectChanges();
        }
      }
    );
    //this.clearLocalStorage();

    if (!this.selfAssessmentId) {
      this.selfAssessmentId = Number(this.route.snapshot.params['id']);
    }
    if (this.filterType === undefined) {
      this.filterType = this.route.snapshot.params['filter'];
    }
    this.getUserMenu();

    if (this.filterType === 'self') {
      this.saT2DetailHistory = new SelfAssessmentT2DetailHistory();
      this.fetchSelfAssessmentDetails();
      this.fetchSADetailsHistory();
      this.fetchSelfAssessmentDD();
      this.getOwnerDD();
      this.fetchSelfAssessmentAllDropdownList();
    } else {
      this.fetchSelfAssessmentVersionHistoryDetails();
    }
  }
  getUserMenu(): void {
    this.analyticsService
      .getLibraryMenu()
      .subscribe((data: MenuItemModel[]) => {
        this.libraryMenu = data;
      });
  }
  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
      if (this.user && this.user.roleId > 0) {
        this.fetchCurrentUserRole();
      }
      this.ckEditorAccessManageFunction();

      if (window.location.pathname == '/library/rule-book') {
        this.locationName =
          '/self-assessment/details/self/2/' + this.selfAssessmentId;
      } else {
        this.locationName = window.location.pathname;
      }
      this.onJoiningPage();
    });
  }
  ckEditorAccessManageFunction() {
    let assessor: any[] = this.selfAssessmentNew.assessor
      ? this.selfAssessmentNew.assessor.split(',')
      : [];
    let owner: any[] = this.selfAssessmentNew.owner
      ? this.selfAssessmentNew.owner.split(',')
      : [];
    let reviewer: any[] = this.selfAssessmentNew.reviewer
      ? this.selfAssessmentNew.reviewer.split(',')
      : [];
    let approver: any[] = this.selfAssessmentNew.approvers
      ? this.selfAssessmentNew.approvers.split(',')
      : [];

    const set = new Set([...assessor, ...owner]);
    const reviewerSet = new Set([...reviewer]);
    const approverSet = new Set([...approver]);

    let newArray = Array.from(set);
    let reviewerArray = Array.from(reviewerSet);
    let approverArray = Array.from(approverSet);
    this.gdprService
      .getCurrentUserRole(this.user.roleId)
      .subscribe((data: Role) => {
        this.currentUserRole = data.title;
        if (this.currentUserRole == 'Compliance Enterprise') {
          if (
            this.selfAssessmentNew.approvalStatus == 'Approved' &&
            this.isApprovedForDisable
          ) {
            this.accessType = revisionHistoryAccessTypeEnum.Readonly;
            this.reviewAccessType = revisionHistoryAccessTypeEnum.Readonly;
            this.approverAccessType = revisionHistoryAccessTypeEnum.Readonly;
          } else {
            this.accessType = revisionHistoryAccessTypeEnum.All;
            this.reviewAccessType = revisionHistoryAccessTypeEnum.All;
            this.approverAccessType = revisionHistoryAccessTypeEnum.All;
          }
        } else if (
          newArray.includes(this.user.fullName) ||
          reviewerArray.includes(this.user.fullName) ||
          approverArray.includes(this.user.fullName)
        ) {
          if (newArray.includes(this.user.fullName)) {
            if (
              newArray.includes(this.user.fullName) &&
              this.selfAssessmentNew.approvalStatus != 'Approved'
            ) {
              this.accessType = revisionHistoryAccessTypeEnum.All;
            } else if (
              this.selfAssessmentNew.approvalStatus == 'Approved' &&
              this.isApprovedForDisable
            ) {
              this.accessType = revisionHistoryAccessTypeEnum.Readonly;
            } else if (
              newArray.includes(this.user.fullName) &&
              this.selfAssessmentNew.approvalStatus == 'Approved' &&
              !this.isApprovedForDisable
            ) {
              this.accessType = revisionHistoryAccessTypeEnum.All;
              this.openEditor();
            } else {
              this.accessType = revisionHistoryAccessTypeEnum.CommentOnly;
            }
            this.reviewAccessType = revisionHistoryAccessTypeEnum.CommentOnly;
            this.approverAccessType = revisionHistoryAccessTypeEnum.CommentOnly;
          }
          if (reviewerArray.includes(this.user.fullName)) {
            if (this.selfAssessmentNew.approvalStatus != 'Approved') {
              this.reviewAccessType = revisionHistoryAccessTypeEnum.All;
            } else if (
              this.selfAssessmentNew.approvalStatus == 'Approved' &&
              this.isApprovedForDisable
            ) {
              this.reviewAccessType = revisionHistoryAccessTypeEnum.Readonly;
            } else if (
              this.selfAssessmentNew.approvalStatus == 'Approved' &&
              !this.isApprovedForDisable
            ) {
              this.reviewAccessType = revisionHistoryAccessTypeEnum.All;
            } else {
              this.reviewAccessType = revisionHistoryAccessTypeEnum.CommentOnly;
            }
            this.accessType = revisionHistoryAccessTypeEnum.CommentOnly;
            this.approverAccessType = revisionHistoryAccessTypeEnum.CommentOnly;
          }
          if (approverArray.includes(this.user.fullName)) {
            if (
              approverArray.includes(this.user.fullName) &&
              this.selfAssessmentNew.approvalStatus != 'Approved'
            ) {
              this.approverAccessType = revisionHistoryAccessTypeEnum.All;
            } else if (
              this.selfAssessmentNew.approvalStatus == 'Approved' &&
              this.isApprovedForDisable
            ) {
              this.approverAccessType = revisionHistoryAccessTypeEnum.Readonly;
            } else if (
              approverArray.includes(this.user.fullName) &&
              this.selfAssessmentNew.approvalStatus == 'Approved' &&
              !this.isApprovedForDisable
            ) {
              this.approverAccessType = revisionHistoryAccessTypeEnum.All;
            } else {
              this.approverAccessType =
                revisionHistoryAccessTypeEnum.CommentOnly;
            }
            this.accessType = revisionHistoryAccessTypeEnum.CommentOnly;
            this.reviewAccessType = revisionHistoryAccessTypeEnum.CommentOnly;
          }
        } else {
          this.accessType = revisionHistoryAccessTypeEnum.Readonly;
          this.reviewAccessType = revisionHistoryAccessTypeEnum.Readonly;
          this.approverAccessType = revisionHistoryAccessTypeEnum.Readonly;
        }
        this.openEditor();
      });
  }
  fetchCurrentUserRole(): void {
    this.gdprService
      .getCurrentUserRole(this.user.roleId)
      .subscribe((data: Role) => {
        this.currentUserRole = data.title;
        if (this.currentUserRole == 'Compliance Enterprise') {
          this.isOverAllAssessmentDisabled = false;
          this.isInterpretationDisabled = false;
          this.isJudgementDisabled = false;
          this.isGapDisabled = false;
          this.isEnhancementDetailsDisabled = false;
          this.isReviewDetailsDisabled = false;
          this.isApprovalDetailsDisabled = false;
        } else {
          let assessor: any[] = this.selfAssessmentNew.assessor
            ? this.selfAssessmentNew.assessor.split(',')
            : [];
          let reviewer: any[] = this.selfAssessmentNew.reviewer
            ? this.selfAssessmentNew.reviewer.split(',')
            : [];
          let approvers: any[] = this.selfAssessmentNew.approvers
            ? this.selfAssessmentNew.approvers.split(',')
            : [];
          if (assessor.includes(this.user.fullName)) {
            this.isOverAllAssessmentDisabled = false;
            this.isInterpretationDisabled = false;
            this.isJudgementDisabled = false;
            this.isGapDisabled = false;
            this.isEnhancementDetailsDisabled = false;
          }
          if (reviewer.includes(this.user.fullName)) {
            this.isReviewDetailsDisabled = false;
          }
          if (approvers.includes(this.user.fullName)) {
            this.isApprovalDetailsDisabled = false;
          }
        }
      });
  }
  fetchSelfAssessmentDetails(): void {
    this.isLoading = true;
    this.gdprService
      .getSelfAssessmentT2Details(this.selfAssessmentId)
      .subscribe((result: SelfAssessmentNew) => {
        this.effectiveDate = this.dateFormat(result.effectiveDate);
        this.selfAssessmentNew = result;
        if (
          this.selfAssessmentNew.approvalStatus == 'Approved' &&
          this.selfAssessmentNew.assessmentStatus == 'Approved'
        ) {
          this.isApprovedForDisable = true;
          this.ref.detectChanges();
        }
        if (
          this.selfAssessmentNew.confirmApproval != null &&
          this.selfAssessmentNew.confirmApproval != ''
        ) {
          this.confirmApproval = this.parseJsonString(
            this.selfAssessmentNew.confirmApproval
          );
        }

        this.ownerDD = this.selfAssessmentNew.owner
          ? this.selfAssessmentNew.owner.split('|')
          : this.ownerDD;
        this.isLoading = false;
        this.getUserProfile();
        this.fetchFormattedDesc();
        this.getAssessmentDocuments();
      });
  }
  fetchSelfAssessmentVersionHistoryDetails(): void {
    this.isLoading = true;
    this.gdprService
      .getSelfAssessmentT2VersionDetails(this.selfAssessmentId)
      .subscribe((result: SelfAssessmentT2VersionModel) => {
        this.effectiveDate = this.dateFormat(
          result.selfAssessData.effectiveDate
        );
        this.selfAssessmentNew = result.selfAssessData;
        this.isVersioned = true;
        this.changeFields = result.changedFields;
        this.versionNo = this.selfAssessmentNew.versionNumber;
        this.ownerDD = this.selfAssessmentNew.owner
          ? this.selfAssessmentNew.owner.split('|')
          : this.ownerDD;
        this.isLoading = false;
        this.getUserProfile();
        this.selectedDDvalue();
        this.fetchFormattedDesc();
        this.getAssessmentDocuments();
      });
  }

  fetchSelfAssessmentDD(): void {
    this.isLoadingDD = true;
    this.gdprService
      .GetSelfAssessmentT2DD()
      .subscribe((result: SelfAssessmentT2DetailsDD) => {
        this.isLoadingDD = false;
        this.selfAssessmentT2DD = result;
        this.ddListData();
        this.selectedDDvalue();
      });
  }

  fetchSADetailsHistory(): void {
    this.gdprService
      .GetSAT2DetailsHistory(this.selfAssessmentId)
      .subscribe((result: SelfAssessmentT2DetailHistory) => {
        this.saT2DetailHistory = result;
      });
  }
  getOwnerDD() {
    this.regulationService
      .getUserListForOwner()
      .subscribe((res: Array<FilterViewModelForOwner>) => {
        this.allSearchedOwner = res;
      });
  }
  fetchSelfAssessmentAllDropdownList(): void {
    this.isLoadingDD = true;
    this.gdprService
      .getSelfAssessmentT2AllDropdownList()
      .subscribe((result: SelfAssessmentT2AllDropdownList) => {
        this.isLoadingDD = false;
        this.selfAssessmentT2AllDropdownList = result;
        this.assessmentStatus =
          this.selfAssessmentT2AllDropdownList.assessmentStatus;
        this.reviewStatus = this.selfAssessmentT2AllDropdownList.reviewStatus;
        this.assessmentCategory =
          this.selfAssessmentT2AllDropdownList.assessmentCategory;
        this.assessmentTeam =
          this.selfAssessmentT2AllDropdownList.assessmentTeam;
        this.complianceStatus =
          this.selfAssessmentT2AllDropdownList.complianceStatus;
        this.interpretations =
          this.selfAssessmentT2AllDropdownList.interpretation;
        this.judgement = this.selfAssessmentT2AllDropdownList.judgement;
        this.gaps = this.selfAssessmentT2AllDropdownList.gaps;
        this.enhancement = this.selfAssessmentT2AllDropdownList.enhancement;
        this.riskRecommendation =
          this.selfAssessmentT2AllDropdownList.riskRecommendation;
        this.riskRecommendationStatus =
          this.selfAssessmentT2AllDropdownList.riskRecommendationStatus;
        this.reviewerTeam = this.selfAssessmentT2AllDropdownList.reviewerTeam;
        this.approvalTeam = this.selfAssessmentT2AllDropdownList.approvalTeam;
        this.approvalStatus =
          this.selfAssessmentT2AllDropdownList.approvalStatus;
      });
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  dateFormat(effectiveDate: string): any {
    const eDate = effectiveDate
      ? effectiveDate.split('|')[0]
      : MasterHelper.getDateStr(0);
    return MasterHelper.formatDate(eDate, 'YYYY-MM-DD');
  }
  fetchFormattedDesc(): void {
    let desc = '';
    if (this.selfAssessmentNew.title1) {
      desc = desc + this.selfAssessmentNew.title1.trim() + '|';
    }
    if (this.selfAssessmentNew.ruleID) {
      desc = desc + this.selfAssessmentNew.ruleID.trim() + '|';
    }
    if (this.selfAssessmentNew.regulatoryRuleFullRequirement) {
      desc = desc + this.selfAssessmentNew.regulatoryRuleFullRequirement.trim();
    }
    this.formattedDesc = desc ? desc.split('|').join('\n') : '';
  }
  getAssessmentDocuments(): void {
    this.isAssessmentLoader = true;
    this.isReviewLoader = true;
    this.gdprService
      .getSelfAssessmentT2Documents(this.selfAssessmentId)
      .subscribe((result: SelfAssessmentDocumentModel[]) => {
        this.selfAssessmentDocument = result;
        this.isAssessmentLoader = false;
        this.isReviewLoader = false;
      });
  }
  selectedDDvalue(): void {
    this.assessorDD = this.selfAssessmentNew.assessor
      ? this.selfAssessmentNew.assessor.split(',')
      : this.assessorDD;
    this.reviewerDD = this.selfAssessmentNew.reviewer
      ? this.selfAssessmentNew.reviewer.split(',')
      : this.reviewerDD;
    this.approverDD = this.selfAssessmentNew.approvers
      ? this.selfAssessmentNew.approvers.split(',')
      : this.approverDD;
    this.filterUsersDropdowns();
  }
  ddListData(): void {
    this.searchedAssessor = this.selfAssessmentT2DD.assessor;
    this.searchedReviewer = this.selfAssessmentT2DD.reviewer;
    this.searchedApprover = this.selfAssessmentT2DD.approver;

    this.searchAssessorCntrl.valueChanges.subscribe((data: any) => {
      this.searchedAssessor = data
        ? this.filterAssessor(data)
        : this.selfAssessmentT2DD.assessor;
      this.filterUsersDropdowns();
    });
    this.searchReviewerCntrl.valueChanges.subscribe((data: any) => {
      this.searchedReviewer = data
        ? this.filterReviewer(data)
        : this.selfAssessmentT2DD.reviewer;
      this.filterUsersDropdowns();
    });
    this.searchApproverCntrl.valueChanges.subscribe((data: any) => {
      this.searchedApprover = data
        ? this.filterApprover(data)
        : this.selfAssessmentT2DD.approver;
      this.filterUsersDropdowns();
    });
  }

  updateSectionLastEdited(filter: string): void {
    switch (filter) {
      case 'Assessment':
        this.isAssessmentLastEdited = true;
        break;
      case 'Review':
        this.isReviewLastEdited = true;
        break;
      case 'ComplianceGap':
        this.isGapLastEdited = true;
        break;
      case 'Enhancement':
        this.isEnhancementLastEdited = true;
        break;
      case 'Interpretations':
        this.isIntepretationsLastEdited = true;
      case 'Judgement':
        this.isJudgementLastEdited = true;
      case 'Approval':
        if (this.isApprovedForDisable) {
          this.openCopyDialog();
        }
        this.isApprovalLastEdited = true;
    }
  }

  openCopyDialog(): void {
    this.alertDialogModel.HeadingText = 'Open Self Assessment after Approved';
    this.alertDialogModel.BodyText =
      'Do you want to reopen this Self Assessment as it is already approved?';
    this.alertDialogModel.IsAction = true;
    this.alertDialogModel.AlertMsg = 'Approved';

    const dialogRef = this.dialog.open(CopyDialogComponent, {
      width: '450px',
      data: this.alertDialogModel,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.closeEditor();
        this.isApprovedForDisable = false;
        this.getUserProfile();
        if (this.confirmApproval != null) {
          this.confirmApproval.forEach((item) => {
            item.isConfirmed = false;
          });
          this.selfAssessmentNew.lastApproved = null;
          this.selfAssessmentNew.approvalStatus = 'Not started';
          this.selfAssessmentNew.assessmentStatus = 'Not started';
          this.ref.detectChanges();
        }
      } else {
        window.location.reload();
      }
    });
  }

  checkRoutePermission(currentUrl: string): boolean {
    return this.libraryMenu.find(
      (a) => a.screenName === currentUrl && a.parentId != null
    )
      ? true
      : false;
  }

  //Approver Multiselect
  filterApprover(search: string): any {
    return this.searchedApprover.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  addApprover(event: MatChipInputEvent): void {
    if (!this.approverAutocomplete.isOpen) {
      //const value = event.value;

      // if ((value || '').trim()) {
      //   let sameValueRow = this.approverDD.filter((obj) => obj === value);
      //   if (sameValueRow.length == 0) {
      //     (this.approverDD as string[]).push(value);
      //   }
      // }
      event.chipInput!.clear();
      this.searchApproverCntrl.setValue(null);
      // this.updateSectionLastEdited('Approval');
    }
  }
  selectedApproverEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.approverDD.length > 0) {
      let sameValueRow = this.approverDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.approverDD.push(event.option.viewValue);
        this.confirmApproval.push({
          approverName: event.option.viewValue,
          isConfirmed: false,
        });
        let countOfApprover = this.confirmApproval.length;
        let countConfirmed = this.confirmApproval.filter(
          (approval) => approval.isConfirmed
        ).length;
        if (countConfirmed > 0) {
          this.selfAssessmentNew.approvalStatus =
            'Approved (' + countConfirmed + ' of ' + countOfApprover + ')';
        } else {
          this.selfAssessmentNew.approvalStatus = 'Not started';
        }
        this.isConfirmApprovalLastEdited = true;
      }
    } else {
      this.approverDD = [];
      this.approverDD.push(event.option.viewValue);
      this.confirmApproval.push({
        approverName: event.option.viewValue,
        isConfirmed: false,
      });
      let countOfApprover = this.confirmApproval.length;
      let countConfirmed = this.confirmApproval.filter(
        (approval) => approval.isConfirmed
      ).length;
      if (countConfirmed > 0) {
        this.selfAssessmentNew.approvalStatus =
          'Approved (' + countConfirmed + ' of ' + countOfApprover + ')';
      } else {
        this.selfAssessmentNew.approvalStatus = 'Not started';
      }
      this.isConfirmApprovalLastEdited = true;
    }
    this.approverInput.nativeElement.value = '';
    this.searchApproverCntrl.setValue(null);
    this.searchApproverCntrl.disable();
    this.searchApproverCntrl.enable();
    this.updateSectionLastEdited('Approval');
  }
  removeApprover(status: string): void {
    const index = (this.approverDD as string[]).indexOf(status);

    if (index >= 0) {
      this.confirmApproval.splice(index, 1);
      let countOfApprover = this.confirmApproval.length;
      let countConfirmed = this.confirmApproval.filter(
        (approval) => approval.isConfirmed
      ).length;
      if (countConfirmed > 0) {
        if (countConfirmed == countOfApprover) {
          this.selfAssessmentNew.approvalStatus = 'Approved';
          this.selfAssessmentNew.assessmentStatus = 'Approved';
        } else {
          this.selfAssessmentNew.approvalStatus =
            'Approved (' + countConfirmed + ' of ' + countOfApprover + ')';
          this.selfAssessmentNew.assessmentStatus = 'Not started';
        }
      } else {
        this.selfAssessmentNew.approvalStatus = 'Not started';
        this.selfAssessmentNew.assessmentStatus = 'Not started';
      }
      this.isConfirmApprovalLastEdited = true;
      (this.approverDD as string[]).splice(index, 1);
      let ob = new FilterViewModel();
      ob.name = status;
      ob.value = status;
      this.searchedReviewer.push(ob);
      this.searchedAssessor.push(ob);
      this.sortByProperty(this.searchedReviewer, 'name');
      this.sortByProperty(this.searchedAssessor, 'name');
      this.updateSectionLastEdited('Approval');
      this.filterUsersDropdowns();
    }
  }
  // Assessor multiselect
  filterAssessor(search: string): any {
    return this.searchedAssessor.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addAssessor(event: MatChipInputEvent): void {
    if (!this.assessorAutocomplete.isOpen) {
      // const value = event.value;

      // if ((value || '').trim()) {
      //   let sameValueRow = this.assessorDD.filter((obj) => obj === value);
      //   if (sameValueRow.length == 0) {
      //     (this.assessorDD as string[]).push(value);
      //   }
      // }
      event.chipInput!.clear();
      this.searchAssessorCntrl.setValue(null);
      this.updateSectionLastEdited('Assessment');
    }
  }

  selectedAssessorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDD) {
      let sameValueRow = this.assessorDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.assessorDD.push(event.option.viewValue);
      }
    } else {
      this.assessorDD = [];
      this.assessorDD.push(event.option.viewValue);
    }
    this.assessorInput.nativeElement.value = '';
    this.searchAssessorCntrl.setValue(null);
    this.searchAssessorCntrl.disable();
    this.searchAssessorCntrl.enable();
    this.updateSectionLastEdited('Assessment');
  }

  removeAssessor(status: string): void {
    const index = (this.assessorDD as string[]).indexOf(status);
    if (index >= 0) {
      (this.assessorDD as string[]).splice(index, 1);
      this.updateSectionLastEdited('Assessment');
      let ob = new FilterViewModel();
      ob.name = status;
      ob.value = status;
      this.searchedReviewer.push(ob);
      this.searchedApprover.push(ob);
      this.sortByProperty(this.searchedReviewer, 'name');
      this.sortByProperty(this.searchedApprover, 'name');
      this.filterUsersDropdowns();
    }
  }

  // Reviewer multiselect
  filterReviewer(search: string): any {
    return this.searchedReviewer.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addReviewer(event: MatChipInputEvent): void {
    if (!this.reviewerAutocomplete.isOpen) {
      //const value = event.value;

      // if ((value || '').trim()) {
      //   let sameValueRow = this.reviewerDD.filter((obj) => obj === value);
      //   if (sameValueRow.length == 0) {
      //     (this.reviewerDD as string[]).push(value);
      //   }
      // }

      event.chipInput!.clear();
      this.searchReviewerCntrl.setValue(null);
      this.updateSectionLastEdited('Review');
    }
  }

  selectedReviewerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.reviewerDD) {
      let sameValueRow = this.reviewerDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.reviewerDD.push(event.option.viewValue);
      }
    } else {
      this.reviewerDD = [];
      this.reviewerDD.push(event.option.viewValue);
    }
    this.reviewerInput.nativeElement.value = '';
    this.searchReviewerCntrl.setValue(null);
    this.searchReviewerCntrl.disable();
    this.searchReviewerCntrl.enable();
    this.updateSectionLastEdited('Review');
  }

  removeReviewer(status: string): void {
    const index = (this.reviewerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.reviewerDD as string[]).splice(index, 1);
      this.updateSectionLastEdited('Review');
      let ob = new FilterViewModel();
      ob.name = status;
      ob.value = status;
      this.searchedAssessor.push(ob);
      this.searchedApprover.push(ob);
      this.sortByProperty(this.searchedAssessor, 'name');
      this.sortByProperty(this.searchedApprover, 'name');
      this.filterUsersDropdowns();
    }
  }

  //Assessment Evidance File Input

  uploadEvidenceAssessment(): void {
    const fileInput = document.getElementById(
      'uploadEviAssessment'
    ) as HTMLElement;
    fileInput.click();
  }
  handleFileInput(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.Assessment);
    }
    this.uploadEviAssessment.nativeElement.value = '';
  }

  //Interpretation Evidance File Input
  uploadEvidenceInterpretation(): void {
    const fileInput = document.getElementById(
      'uploadEviInterpretation'
    ) as HTMLElement;
    fileInput.click();
  }
  handleInterpretationInput(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.Interpretation);
    }
    this.uploadEviInterpretation.nativeElement.value = '';
  }
  //DataJudgement Evidance File Input
  uploadEvidenceDataJudgement(): void {
    const fileInput = document.getElementById(
      'uploadEviDataJudgement'
    ) as HTMLElement;
    fileInput.click();
  }
  handleDataJudgementInput(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.DataJudgement);
    }
    this.uploadEviDataJudgement.nativeElement.value = '';
  }
  //ComplianceGaps Evidance File Input
  uploadEvidenceComplianceGaps(): void {
    const fileInput = document.getElementById(
      'uploadEviComplianceGaps'
    ) as HTMLElement;
    fileInput.click();
  }
  handleComplianceGapsInput(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.ComplianceGaps);
    }
    this.uploadEviComplianceGaps.nativeElement.value = '';
  }
  //Enhancement Evidance File Input
  uploadEvidenceEnhancement(): void {
    const fileInput = document.getElementById(
      'uploadEviEnhancement'
    ) as HTMLElement;
    fileInput.click();
  }
  handleEnhancementInput(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.Enhancement);
    }
    this.uploadEviEnhancement.nativeElement.value = '';
  }

  uploadFileToActivity(fileToUpload: any, fileType: FileType): void {
    if (fileType === FileType.Assessment) {
      this.isAssessmentLoader = true;
    } else if (fileType === FileType.Interpretation) {
      this.isInterpretationLoader = true;
    } else if (fileType === FileType.DataJudgement) {
      this.isDataJudgementLoader = true;
    } else if (fileType === FileType.ComplianceGaps) {
      this.isComplianceGapsLoader = true;
    } else {
      this.isEnhancementLoader = true;
    }
    this.gdprService
      .UploadEvidenceT2(fileToUpload, fileType, this.selfAssessmentId)
      .subscribe(
        (data: any) => {
          this.fetchSelfAssessmentDocuments(fileType);
          if (fileType === FileType.Assessment) {
            this.isAssessmentLoader = false;
            this.updateSectionLastEdited('Assessment');
          } else if (fileType === FileType.Interpretation) {
            this.isInterpretationLoader = false;
            this.updateSectionLastEdited('Interpretations');
          } else if (fileType === FileType.DataJudgement) {
            this.isDataJudgementLoader = false;
            this.updateSectionLastEdited('Judgement');
          } else if (fileType === FileType.ComplianceGaps) {
            this.isComplianceGapsLoader = false;
            this.updateSectionLastEdited('ComplianceGap');
          } else {
            this.isEnhancementLoader = false;
            this.updateSectionLastEdited('Enhancement');
          }
        },
        (err: HttpErrorResponse) => {
          this.isAssessmentLoader = false;
          this.isInterpretationLoader = false;
          this.isDataJudgementLoader = false;
          this.isComplianceGapsLoader = false;
          this.isEnhancementLoader = false;
          this.alertMessage(
            'warning',
            'File not uploaded, please check your file'
          );
          setTimeout(() => {}, 1000);
        }
      );
  }

  fetchSelfAssessmentDocuments(fileType: FileType): void {
    if (fileType === FileType.Assessment) {
      this.isAssessmentLoader = true;
    } else if (fileType === FileType.Interpretation) {
      this.isInterpretationLoader = true;
    } else if (fileType === FileType.DataJudgement) {
      this.isDataJudgementLoader = true;
    } else if (fileType === FileType.ComplianceGaps) {
      this.isComplianceGapsLoader = true;
    } else {
      this.isEnhancementLoader = true;
    }
    this.gdprService
      .getSelfAssessmentT2Documents(this.selfAssessmentId)
      .subscribe((result: SelfAssessmentDocumentModel[]) => {
        this.selfAssessmentDocument = result;
        if (fileType === FileType.Assessment) {
          this.isAssessmentLoader = false;
        } else if (fileType === FileType.Interpretation) {
          this.isInterpretationLoader = false;
        } else if (fileType === FileType.DataJudgement) {
          this.isDataJudgementLoader = false;
        } else if (fileType === FileType.ComplianceGaps) {
          this.isComplianceGapsLoader = false;
        } else {
          this.isEnhancementLoader = false;
        }
      });
  }

  openDeleteModel(id: number, fileType: string): void {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to delete?',
        title: 'Delete Document',
        btnText: 'Delete',
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.removeSelfAssessmentDocuments(id, fileType);
      }
    });
  }

  removeSelfAssessmentDocuments(id: number, fileType: string): void {
    if (fileType === 'Assessment') {
      this.isAssessmentLoader = true;
    } else if (fileType === 'Interpretation') {
      this.isInterpretationLoader = true;
    } else if (fileType === 'DataJudgement') {
      this.isDataJudgementLoader = true;
    } else if (fileType === 'ComplianceGaps') {
      this.isComplianceGapsLoader = true;
    } else {
      this.isEnhancementLoader = true;
    }
    this.gdprService
      .deleteSelfAssessmentT2Document(id)
      .subscribe((data: any) => {
        if (fileType === 'Assessment') {
          this.isAssessmentLoader = false;
          this.fetchSelfAssessmentDocuments(FileType.Assessment);
        } else if (fileType === 'Interpretation') {
          this.isInterpretationLoader = false;
          this.fetchSelfAssessmentDocuments(FileType.Interpretation);
        } else if (fileType === 'DataJudgement') {
          this.isDataJudgementLoader = false;
          this.fetchSelfAssessmentDocuments(FileType.DataJudgement);
        } else if (fileType === 'ComplianceGaps') {
          this.isComplianceGapsLoader = false;
          this.fetchSelfAssessmentDocuments(FileType.ComplianceGaps);
        } else {
          this.isEnhancementLoader = false;
          this.fetchSelfAssessmentDocuments(FileType.Enhancement);
        }
        if (data.result) {
          this.alertMessage('success', data.result);
        }
      });
  }

  downloadDocument(
    id: number,
    fileName: string,
    extension: string,
    fileType: string
  ): void {
    if (fileType === 'Assessment') {
      this.isAssessmentLoader = true;
    } else if (fileType === 'Interpretation') {
      this.isInterpretationLoader = true;
    } else if (fileType === 'DataJudgement') {
      this.isDataJudgementLoader = true;
    } else if (fileType === 'ComplianceGaps') {
      this.isComplianceGapsLoader = true;
    } else {
      this.isEnhancementLoader = true;
    }
    this.gdprService.downloadEvidenceT2(id).subscribe(
      (data: any) => {
        if (fileType === 'Assessment') {
          this.isAssessmentLoader = false;
        } else if (fileType === 'Interpretation') {
          this.isInterpretationLoader = false;
        } else if (fileType === 'DataJudgement') {
          this.isDataJudgementLoader = false;
        } else if (fileType === 'ComplianceGaps') {
          this.isComplianceGapsLoader = false;
        } else {
          this.isEnhancementLoader = false;
        }
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `${fileName}${extension}`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      }
    );
  }

  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }

  openDialog(): void {
    const filterDataModel = new VersionFilterViewT2Model();
    filterDataModel.selfAssessment = this.selfAssessmentNew;
    filterDataModel.versionId = this.selfAssessmentId;
    filterDataModel.filterType = this.filterType;
    filterDataModel.templateId = 2;
    const dialogRef = this.dialog.open(SelfAssessmentDialogComponent, {
      data: filterDataModel,
      width: '750px',
    });

    dialogRef.afterClosed().subscribe(() => {});
  }
  async updateSelfAssessment() {
    this.isSaved = true;
    this.isLoading = true;

    //Last edited Work
    if (
      this.selfAssessmentNew.assessmentDueDate != null &&
      this.selfAssessmentNew.assessmentCategory != null &&
      this.selfAssessmentNew.assessmentCategory != '' &&
      this.selfAssessmentNew.complianceStatus != null &&
      this.selfAssessmentNew.complianceStatus != '' &&
      this.selfAssessmentNew.assessmentDescription != null &&
      this.selfAssessmentNew.assessmentDescription != '' &&
      this.selfAssessmentNew.assessmentTeam != null &&
      this.selfAssessmentNew.assessmentTeam != '' &&
      this.selfAssessmentNew.assessmentStatus != null &&
      this.selfAssessmentNew.assessmentStatus != ''
    ) {
      if (this.isAssessmentLastEdited) {
        this.selfAssessmentNew.assessmentLastEdited = MasterHelper.getDate(0);
      }
      if (this.isReviewLastEdited) {
        this.selfAssessmentNew.reviewLastEdited = MasterHelper.getDate(0);
      }
      if (this.isGapLastEdited) {
        this.selfAssessmentNew.gapsLastEdited = MasterHelper.getDate(0);
      }
      if (this.isEnhancementLastEdited) {
        this.selfAssessmentNew.enhancementLastEdited = MasterHelper.getDate(0);
      }
      if (this.isIntepretationsLastEdited) {
        this.selfAssessmentNew.interpretationLastEdited =
          MasterHelper.getDate(0);
      }
      if (this.isJudgementLastEdited) {
        this.selfAssessmentNew.judgementLastEdited = MasterHelper.getDate(0);
      }
      if (this.isApprovalLastEdited) {
        this.selfAssessmentNew.approvalLastEdited = MasterHelper.getDate(0);
      }
      let isApproved = this.confirmApproval.some(
        (approval) => approval.isConfirmed === true
      );
      if (this.isConfirmApprovalLastEdited && isApproved) {
        this.selfAssessmentNew.lastApproved = MasterHelper.getDate(0);
      } else if (!isApproved) {
        this.selfAssessmentNew.lastApproved = null;
      }
      //Username dropdown field work
      this.selfAssessmentNew.assessor = this.assessorDD.toString();
      this.selfAssessmentNew.reviewer = this.reviewerDD.toString();
      this.selfAssessmentNew.approvers = this.approverDD.toString();
      if (this.confirmApproval != null) {
        this.selfAssessmentNew.confirmApproval = JSON.stringify(
          this.confirmApproval
        );
      }
      this.selfAssessmentNew.assessmentLastEdited = this.selfAssessmentNew
        .assessmentLastEdited
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.assessmentLastEdited.toString()
          )
        : null;
      this.selfAssessmentNew.assessmentDueDate = this.selfAssessmentNew
        .assessmentDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.assessmentDueDate.toString()
          )
        : null;
      this.selfAssessmentNew.gapActionDueDate = this.selfAssessmentNew
        .gapActionDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.gapActionDueDate.toString()
          )
        : null;
      this.selfAssessmentNew.reviewLastEdited = this.selfAssessmentNew
        .reviewLastEdited
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.reviewLastEdited.toString()
          )
        : null;
      this.selfAssessmentNew.interpretationLastEdited = this.selfAssessmentNew
        .interpretationLastEdited
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.interpretationLastEdited.toString()
          )
        : null;
      this.selfAssessmentNew.judgementLastEdited = this.selfAssessmentNew
        .judgementLastEdited
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.judgementLastEdited.toString()
          )
        : null;
      this.selfAssessmentNew.enhancementLastEdited = this.selfAssessmentNew
        .enhancementLastEdited
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.enhancementLastEdited.toString()
          )
        : null;
      this.selfAssessmentNew.riskRecommendationDueDate = this.selfAssessmentNew
        .riskRecommendationDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.riskRecommendationDueDate.toString()
          )
        : null;
      this.selfAssessmentNew.gapsLastEdited = this.selfAssessmentNew
        .gapsLastEdited
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.gapsLastEdited.toString()
          )
        : null;
      this.selfAssessmentNew.approvalLastEdited = this.selfAssessmentNew
        .approvalLastEdited
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.approvalLastEdited.toString()
          )
        : null;
      this.selfAssessmentNew.lastApproved = this.selfAssessmentNew.lastApproved
        ? MasterHelper.bsdatePickerToCorrectDate(
            this.selfAssessmentNew.lastApproved.toString()
          )
        : null;
      const currentUrl = window.location.href;
      this.selfAssessmentNew.riskRecommendation = this.selfAssessmentNew
        .riskRecommendation
        ? this.selfAssessmentNew.riskRecommendation.toString()
        : '';
      this.updateSADetails.selfAssessmentDetails = this.selfAssessmentNew;
      //this.clearLocalStorage();
      this.closeEditor();
      if (this.ckEditorComponent) {
        this.ckEditorComponent.forEach(async (editor) => {
          if (editor?.buttonActive) {
            await editor?.CalledUpdatedSelfAssessmentData();
            this.broadCastMessageOnEditorSave();
          }
        });
      }

      // if (this.ckEditorComponent?.buttonActive) {
      //   await this.ckEditorComponent?.CalledUpdatedSelfAssessmentData();
      // }
      this.gdprService
        .updateSelfAssessmentT2(this.updateSADetails, currentUrl)
        .subscribe((result: SelfAssessmentNew) => {
          this.selfAssessmentNew = result;
          this.fetchCurrentUserRole();
          if (this.selfAssessmentNew.approvalStatus == "Approved" && this.selfAssessmentNew.assessmentStatus == "Approved") {
            this.isApprovedForDisable = true;
            this.ref.detectChanges();
          }
          this.alertMessage('success', 'Successfully updated');
          this.isSaved = false;
          this.isLoading = false;
          this.ref.detectChanges();

          this.updateSADetails = new UpdateSelfAssessmentT2Model();
          this.fetchSADetailsHistory();

          this.openEditor();
          this.ckEditorAccessManageFunction();
        });
    } else {
      this.alertMessage('warning', '* fields are required.');
      this.isSaved = false;
      this.isLoading = false;
    }
  }
  toggleConfirmation(approval: ConfirmApprove): void {
    let currentApprover = this.confirmApproval.findIndex(
      (a) => a.approverName == approval.approverName
    );
    let countOfApprover = this.confirmApproval.length;
    if (approval.isConfirmed) {
      this.confirmApproval[currentApprover].isConfirmed = true;
      let countConfirmed = this.confirmApproval.filter(
        (approval) => approval.isConfirmed
      ).length;
      if (countConfirmed == countOfApprover) {
        this.selfAssessmentNew.approvalStatus = 'Approved';
        this.selfAssessmentNew.assessmentStatus = 'Approved';
      } else {
        this.selfAssessmentNew.approvalStatus =
          'Approved (' + countConfirmed + ' of ' + countOfApprover + ')';
        this.selfAssessmentNew.assessmentStatus = 'Not started';
      }
    } else {
      this.confirmApproval[currentApprover].isConfirmed = false;
      this.selfAssessmentNew.approvalStatus = 'Not started';
      this.selfAssessmentNew.assessmentStatus = 'Not started';
    }
    this.isConfirmApprovalLastEdited = true;
    this.updateSectionLastEdited('Approval');
  }
  parseJsonString(jsonString: string): ConfirmApprove[] {
    try {
      const data = JSON.parse(jsonString);
      if (Array.isArray(data)) {
        return data.map((item: any) => {
          return {
            approverName: item.approverName || '',
            isConfirmed: !!item.isConfirmed,
          } as ConfirmApprove;
        });
      }
    } catch (error) {
      console.error('Error parsing JSON string:', error);
    }
    return [];
  }
  ckEditorData: string = '';
  updateUserList(userlist: string, newUser: string): string {
    if (userlist) {
      const userList: string[] = userlist.split(',');
      const isPresent: boolean = userList.includes(newUser);
      if (!isPresent) {
        userList.push(newUser);
      }
      userlist = userList.join(',');
    } else {
      userlist = newUser;
    }
    return userlist;
  }
  onChildVariableChange(data: any, type: string): void {
    if (type.toLowerCase() === 'assessmentDetails'.toLocaleLowerCase()) {
      this.selfAssessmentNew.assessmentDetails = data;
      this.selfAssessmentNew.muteOverallStatusUser = this.updateUserList(
        this.selfAssessmentNew.muteOverallStatusUser,
        this.user.fullName
      );
      this.selfAssessmentNew.assessmentLastEdited = new Date(
        MasterHelper.getDate(0)
      );
      this.ref.detectChanges();
    }
    if (type.toLowerCase() === 'interpretationDetails'.toLocaleLowerCase()) {
      this.selfAssessmentNew.interpretationDetails = data;
      this.selfAssessmentNew.muteOverallStatusUser = this.updateUserList(
        this.selfAssessmentNew.muteOverallStatusUser,
        this.user.fullName
      );
      this.selfAssessmentNew.interpretationLastEdited = new Date(
        MasterHelper.getDate(0)
      );
      this.ref.detectChanges();
    }
    if (type.toLowerCase() === 'judgementDetails'.toLocaleLowerCase()) {
      this.selfAssessmentNew.judgementDetails = data;
      this.selfAssessmentNew.muteOverallStatusUser = this.updateUserList(
        this.selfAssessmentNew.muteOverallStatusUser,
        this.user.fullName
      );
      this.selfAssessmentNew.judgementLastEdited = new Date(
        MasterHelper.getDate(0)
      );
      this.ref.detectChanges();
    }
    if (type.toLowerCase() === 'gapDetail'.toLocaleLowerCase()) {
      this.selfAssessmentNew.gapDetail = data;
      this.selfAssessmentNew.muteOverallStatusUser = this.updateUserList(
        this.selfAssessmentNew.muteOverallStatusUser,
        this.user.fullName
      );
      this.selfAssessmentNew.gapsLastEdited = new Date(MasterHelper.getDate(0));
      this.ref.detectChanges();
    }
    if (type.toLowerCase() === 'enhancementDescription'.toLocaleLowerCase()) {
      this.selfAssessmentNew.enhancementDescription = data;
      this.selfAssessmentNew.muteOverallStatusUser = this.updateUserList(
        this.selfAssessmentNew.muteOverallStatusUser,
        this.user.fullName
      );
      this.selfAssessmentNew.enhancementLastEdited = new Date(
        MasterHelper.getDate(0)
      );
      this.ref.detectChanges();
    }
    if (type.toLowerCase() === 'reviewDetails'.toLocaleLowerCase()) {
      this.selfAssessmentNew.reviewDetails = data;
      this.selfAssessmentNew.muteReviewUser = this.updateUserList(
        this.selfAssessmentNew.muteReviewUser,
        this.user.fullName
      );
      this.selfAssessmentNew.reviewLastEdited = new Date(
        MasterHelper.getDate(0)
      );
      this.ref.detectChanges();
    }
    if (type.toLowerCase() === 'approvalComment'.toLocaleLowerCase()) {
      this.selfAssessmentNew.approvalComment = data;
      this.selfAssessmentNew.muteApproverUser = this.updateUserList(
        this.selfAssessmentNew.muteApproverUser,
        this.user.fullName
      );
      this.selfAssessmentNew.approvalLastEdited = new Date(
        MasterHelper.getDate(0)
      );
      this.ref.detectChanges();
    }
  }
  // clearLocalStorage(): void {
  //   let ckEditorList = ['assessmentDetails', 'interpretationDetails', 'judgementDetails', 'gapDetail', 'enhancementDescription', 'reviewDetails', 'approvalComment']
  //   ckEditorList.forEach(element => {
  //     localStorage.removeItem('editorData-' + element);
  //     localStorage.removeItem('userComment-' + element);
  //     localStorage.removeItem("revisionHistoryData-" + element);
  //     localStorage.removeItem('userComment-' + element);
  //     localStorage.removeItem("trackChanges-" + element);
  //   });
  // }
  openEditor() {
    this.isSADetails1 = true;
    this.isSADetails2 = true;
    this.isSADetails3 = true;
    this.isSADetails4 = true;
    this.isSADetails5 = true;
    this.isSADetails6 = true;
    this.isSADetails7 = true;
  }
  closeEditor() {
    this.isSADetails1 = false;
    this.isSADetails2 = false;
    this.isSADetails3 = false;
    this.isSADetails4 = false;
    this.isSADetails5 = false;
    this.isSADetails6 = false;
    this.isSADetails7 = false;
  }
  async onEditorSave(data: SelfAssessmentCkDataSaveModel) {
    this.gdprService.updateSelfAssessmentCKT2(data).subscribe((res: any) => {
      this.broadCastMessageOnEditorSave();
    });
  }
  broadCastMessageOnEditorSave(){
    let boradcastMessage = new ckEditorBroadcastMessage();
    boradcastMessage.selfAssessmentId = this.selfAssessmentId;
    boradcastMessage.userId = this.user.externalUserId;
    boradcastMessage.userName = this.user.fullName;
    this.signalRService
      .broadcastMessage(boradcastMessage)
      .subscribe((result: any) => {});
  }
  async onJoiningPage() {
    let boradcastMessage = new ckEditorBroadcastMessage();
    boradcastMessage.selfAssessmentId = this.selfAssessmentId;
    boradcastMessage.userId = this.user.externalUserId;
    boradcastMessage.userName = this.user.fullName;
    boradcastMessage.url = this.locationName;
    this.signalRService
      .JoinSelfAssessmentT2Page(boradcastMessage)
      .subscribe((result: any) => {});
  }
  async onLeavingPage() {
    let boradcastMessage = new ckEditorBroadcastMessage();
    boradcastMessage.selfAssessmentId = this.selfAssessmentId;
    boradcastMessage.userId = this.user.externalUserId;
    boradcastMessage.userName = this.user.fullName;
    boradcastMessage.url = this.locationName;
    this.signalRService
      .LeaveSelfAssessmentT2Page(boradcastMessage)
      .subscribe((result: any) => {});
  }
  @HostListener('window:beforeunload', ['$event'])
  unloadHandler($event: any): void {
    this.onLeavingPage();
    // Make API call before leaving the page
  }
  onNavigationStart() {
    // Your logic when navigation starts (e.g., clicking on a navbar link)
    this.onLeavingPage();
  }
  public ngAfterViewInit(): void {}
  isListVisible: boolean = false;

  toggleListVisibility() {
    this.isListVisible = !this.isListVisible;
  }
  // filter accessor and reviewer and approver
  filterUsersDropdowns() {
    this.searchedReviewer = this.searchedReviewer.filter((assessorObj) => {
      return !this.assessorDD.includes(assessorObj.name);
    });
    this.searchedReviewer = this.searchedReviewer.filter((assessorObj) => {
      return !this.approverDD.includes(assessorObj.name);
    });
    this.searchedAssessor = this.searchedAssessor.filter((assessorObj) => {
      return !this.reviewerDD.includes(assessorObj.name);
    });
    this.searchedAssessor = this.searchedAssessor.filter((assessorObj) => {
      return !this.approverDD.includes(assessorObj.name);
    });
    this.searchedApprover = this.searchedApprover.filter((assessorObj) => {
      return !this.reviewerDD.includes(assessorObj.name);
    });
    this.searchedApprover = this.searchedApprover.filter((assessorObj) => {
      return !this.assessorDD.includes(assessorObj.name);
    });

    // this.searchedAssessor = this.searchedAssessor.filter(item => item.name != this.user.fullName);
    // this.searchedReviewer = this.searchedReviewer.filter(item => item.name != this.user.fullName);
    // this.searchedApprover = this.searchedApprover.filter(item => item.name != this.user.fullName);
  }
  sortByProperty(arr: any[], prop: string) {
    arr.sort((a, b) => {
      if (a[prop] < b[prop]) {
        return -1;
      }
      if (a[prop] > b[prop]) {
        return 1;
      }
      return 0;
    });
  }

  //For Opening Rule Detail from Self Assessment Details
  openView(id: number, detailType: number) {
    const dialogRef = this.dialog.open(ChangeDetailComponent, {
      width: '1800px',
      height: '870px',
      data: {
        id: id,
        detailType: detailType,
        ruleArr: null,
        filterType: 'All',
        type: 'modal',
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      // this.ruleBookViewCloseData = result;
      // if (result) {
      //   const index = this.ruleBooks.data.findIndex(
      //     (item) => item.id === result.Id
      //   );
      //   if (index !== -1) {
      //     this.ruleBooks.data[index].applicable = result.IsApplicable;
      //     this.ruleBooks.data[index].operative = result.IsOperative;
      //     this.ruleBooks.data[index].isRead = result.IsRead;
      //     this.ruleBooks.data[index].owner = result.ownerList;
      //   }
      // }
      // this.sessionService.isLibraryTabActive = false;
    });
  }
   //previous next button add
   checkSibling(id: number, type: string): boolean {
    const index = this.idList.findIndex((a) => Number(a)=== Number(id));
    if (index < 0) {
      return false;
    } else {
      if (type === 'Next') {
        return this.idList[index + 1] ? true : false;
      } else {
        return this.idList[index - 1] ? true : false;
      }
    }
  }
  getSiblings(type: string): void {
    const index = this.idList.findIndex(
      (a) => Number(a) === Number(this.selfAssessmentId));
    if (type === 'Next') {
      this.selfAssessmentId = this.idList[index + 1];
    } else {
      this.selfAssessmentId = this.idList[index - 1];
    }
    this.redirectLink();
  }
  redirectLink() {
    let link = '/self-assessment/details/self/2/' + this.selfAssessmentId + '';
    const navigationExtras: NavigationExtras = {
      state: { idList: this.idList }
    };
   this.router.navigate([link], navigationExtras);
  }
}

